import { type PartialDeep } from 'type-fest';

import { type PropertiesConfigInputVisualEffectModel } from '@blaze-shared/elements-domain';

import { PropsExtractor } from '../__base/props-extractor';

export class MapPropsExtractor extends PropsExtractor<'map'> {
  override getVisualEffect: () => PartialDeep<PropertiesConfigInputVisualEffectModel> | undefined =
    () => this.props?.style?.map?.effect;
}
